<template>
    <div style="" class="col-md-4 left-level-1  bgColorLeft   d-flex justify-content-center">
        <img src="/img/person.jpg" class="person rounded-circle  shadow" :class="{'animation':photoView}" />
    </div>
</template>

<script>
    export default {
        data() {
            return {
                photoView: false
            }
        },
        mounted () {
            setTimeout(() => {this.photoView = true}, 5000);
        },
    }
</script>

<style lang="scss" scoped>

.shadow {
    -webkit-box-shadow: 5px 5px 45px 5px rgba(0,0,0,0.55); 
    box-shadow: 5px 5px 45px 5px rgba(0,0,0,0.55);    
    opacity:0;
}

.animation {
    opacity:1;
    width:200px;
    height:200px;
    position: relative;
    animation: fadeIn 10s;
}

@keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}
</style>